/**
 * ============================================================================
 * USER / TENANT SERVICE: WhatsApp Messages & Audit Log (Sheets 26 & 31)
 * ============================================================================
 * Purpose:
 *   Handles customer inbound chats (`tbl_incoming_messages`) and
 *   centralized transmission audit logs (`tbl_message_log`).
 *
 * Database Scope:
 *   Tenant Database (`digi_user_<id>`)
 * ============================================================================
 */

import { createCrudService } from "../../core/services/crudServiceFactory";

const incomingMessageService = createCrudService("tenant/messages/incoming");
const messageLogService = createCrudService("tenant/messages/logs");

const messageService = {
  incoming: incomingMessageService,
  logs: messageLogService,
};

export default messageService;
